function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var genTaskStyles = function genTaskStyles(prefixCls, token) {
  return [_defineProperty({}, ".".concat(prefixCls), _defineProperty({
    // 100vh - 导航 - 间距
    height: 'calc(100vh - 48px - 16px)',
    // display: 'none',
    margin: 8,
    background: '#fff'
  }, ".task-container", _defineProperty(_defineProperty({
    height: '100%',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    minHeight: 0
  }, ".top-divider", {
    margin: 0
  }), ".bottom", _defineProperty(_defineProperty({
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'row'
  }, ".left", {
    minWidth: 0,
    minHeight: 0,
    width: '340px',
    borderRight: '1px solid #f0f0f0',
    flexShrink: 0
  }), ".right", {
    minWidth: 0,
    minHeight: 0,
    display: 'flex',
    flex: 1
  }))))];
};